import { Attributes, Misc, ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';
import { DayOfMonthType } from './DayOfMonthType.enum';
import DateCycle from './DateCycle';

@NeoModel
export default class DateCycleDate extends ModelBase {

    public dateCycleDateId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public dateCycleId: number | null = null;

    @Attributes.Parent(() => DateCycle)
    public dateCycle: DateCycle | null = null;

    @Attributes.Integer()
    public month: number = 0;

    public dayOfMonth: DayOfMonthType | null = null;

    @Attributes.Nullable()
    @Attributes.Integer()
    public day: number | null = null;

    // Client only properties / methods

    public get dayOfMonthValue() {
        return this.dayOfMonth ?? this.dateCycle?.dayOfMonthType;
    }

    public onDayOfMonthTypeChanged() {
        if (this.dayOfMonthValue !== DayOfMonthType.Custom) {
            this.day = null;
        }
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => !c.dayOfMonthValue, "Day of month must be specified on the cycle, or on this record.").onProperties(c => c.dayOfMonth);
        rules.failWhen(c => (c.day != null) != (c.dayOfMonthValue === DayOfMonthType.Custom), "Day must be specified if DayOfMonth type is 'Custom'.");
    }

    public toString(): string {
        if (this.isNew) {
            return "New date cycle date";
        } else {
            return "Date Cycle Date";
        }
    }
}